package com.dotdrives.web.pages.giving

import react.FC
import react.Props
import react.dom.html.ReactHTML.style

val PublicGivingStyles =
    FC<Props> {
        style {
            +"""
        .give-layout {
            display:grid;
            grid-template-columns:minmax(340px, 46%) 1fr;
            min-height:100vh;
            color:#222D32;
            background:white;
            font-family:'Nunito Sans',sans-serif;
        }
        .give-story {
            background:#222D32;
            color:white;
            padding:60px 64px;
            display:flex;
            flex-direction:column;
            border-top:6px solid #F26223;
        }
        .give-brand {
            font-family:'Quicksand',sans-serif;
            font-size:23px;
            font-weight:700;
            display:flex;
            align-items:center;
            gap:14px;
            margin-bottom:95px;
            overflow-wrap:anywhere;
        }
        .give-logo {
            width:48px;
            height:48px;
            object-fit:contain;
            background:white;
            border-radius:12px;
            padding:4px;
        }
        .give-eyebrow {
            font-family:'IBM Plex Mono',monospace;
            font-size:11px;
            letter-spacing:2px;
            color:#F9AC89;
            font-weight:500;
            margin-bottom:18px;
        }
        .give-story h1 {
            font-family:'Quicksand',sans-serif;
            font-size:44px;
            line-height:1.2;
            letter-spacing:-1px;
            margin:0 0 24px;
            max-width:560px;
            overflow-wrap:anywhere;
        }
        .give-story-copy {
            font-size:17px;
            line-height:1.75;
            color:#E4E8EC;
            white-space:pre-wrap;
            max-width:520px;
        }
        .give-story-expand { display:none; border:0; background:transparent; color:#F9AC89; text-align:left; padding:8px 0 0; font:800 13px 'Nunito Sans',sans-serif; cursor:pointer; }
        .give-progress {
            margin:35px 0 20px;
            padding:24px;
            border:1px solid #536168;
            background:#2B373D;
            border-radius:16px;
        }
        .give-progress-numbers {
            display:flex;
            flex-wrap:wrap;
            gap:10px;
            justify-content:space-between;
            align-items:baseline;
        }
        .give-progress strong {
            font-family:'IBM Plex Mono',monospace;
            font-size:24px;
        }
        .give-progress span,.give-progress p {
            font-size:13px;
            color:#D3DBE0;
        }
        .give-progress progress {
            width:100%;
            height:9px;
            border:0;
            border-radius:99px;
            overflow:hidden;
            margin-top:20px;
            accent-color:var(--give-accent,#F26223);
            background:#526067;
        }
        .give-progress progress::-webkit-progress-bar {
            background:#526067;
        }
        .give-progress progress::-webkit-progress-value {
            background:#F26223;
        }
        .give-story-foot {
            margin-top:auto;
            padding-top:70px;
            color:#C3CCD2;
            font-size:12px;
        }
        .give-panel {
            padding:54px 48px 24px;
        }
        .give-form {
            max-width:480px;
            margin:auto;
        }
        .give-form h2,.give-unavailable h1 {
            font-family:'Quicksand',sans-serif;
            font-size:29px;
            line-height:1.3;
            margin:0 0 10px;
        }
        .give-intro {
            color:#5A6870;
            font-size:15px;
            margin:0 0 24px;
        }
        .give-form fieldset {
            border:0;
            padding:0;
            margin:26px 0;
            min-width:0;
        }
        .give-form legend {
            font-weight:800;
            font-size:15px;
            margin-bottom:14px;
        }
        .give-frequency {
            display:grid;
            grid-template-columns:1fr 1fr;
            background:#EFF1F4;
            padding:4px;
            border-radius:99px;
            margin-bottom:18px;
        }
        .give-form button {
            font:800 14px 'Nunito Sans',sans-serif;
            cursor:pointer;
        }
        .give-frequency button {
            border:0;
            background:transparent;
            min-height:44px;
            border-radius:99px;
            color:#5A6870;
        }
        .give-frequency .selected {
            background:white;
            color:#222D32;
            box-shadow:0 1px 4px #222D3220;
        }
        .give-amounts {
            display:grid;
            grid-template-columns:repeat(2,minmax(0,1fr));
            gap:12px;
        }
        .give-amount {
            display:flex;
            flex-direction:column;
            align-items:center;
            justify-content:center;
            gap:5px;
            min-height:80px;
            border:1px solid #E4E8EC;
            border-radius:14px;
            background:white;
            color:#222D32;
            padding:12px;
        }
        .give-amount strong,.give-total strong {
            font-family:'IBM Plex Mono',monospace;
            font-size:22px;
        }
        .give-amount span {
            font-size:12px;
            color:#5A6870;
            overflow-wrap:anywhere;
        }
        .give-amount.selected {
            border:2px solid var(--give-accent,#F26223);
            background:color-mix(in srgb,var(--give-accent,#F26223) 12%,white);
        }
        .give-field {
            display:flex;
            flex-direction:column;
            gap:7px;
            margin:16px 0;
            font-size:13px;
            font-weight:800;
        }
        .give-field input,.give-field select,.give-field textarea {
            width:100%;
            box-sizing:border-box;
            min-height:46px;
            border:1px solid #D2D9DE;
            background:#fff;
            border-radius:9px;
            padding:11px 13px;
            font:400 16px 'Nunito Sans',sans-serif;
            color:#222D32;
        }
        .give-field textarea {
            min-height:95px;
        }
        .give-form input:focus-visible,.give-form button:focus-visible,.give-form select:focus-visible,.give-form textarea:focus-visible,.give-form a:focus-visible {
            outline:3px solid #4696EC;
            outline-offset:3px;
        }
        .give-contact-grid {
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 0 12px;
        }
        .give-contact-grid > label {
            grid-column: 1 / -1;
        }
        .give-contact-grid > .give-name-field {
            grid-column: auto;
        }
        .give-check {
            display:flex;
            gap:10px;
            align-items:flex-start;
            margin:18px 0;
            font-size:13px;
            line-height:1.55;
            color:#5A6870;
            cursor:pointer;
        }
        .give-check input {
            accent-color:var(--give-accent,#F26223);
            width:18px;
            height:18px;
            flex:none;
            margin-top:2px;
        }
        .give-matching {
            background:#EFF1F4;
            border:1px solid #E4E8EC;
            border-radius:12px;
            padding:18px;
            font-size:13px;
            margin:22px 0;
        }
        .give-matching p {
            line-height:1.6;
            margin:9px 0;
            color:#5A6870;
        }
        .give-matching a {
            color:#2B6CB8;
        }
        .give-notice {
            padding:16px;
            border-radius:12px;
            background:#FFF6E5;
            color:#795200;
            font-size:13px;
            line-height:1.55;
            margin:18px 0;
        }
        .give-notice p {
            margin:6px 0 0;
        }
        .give-error {
            background:#FDECEA;
            color:#C22C25;
            border:1px solid #C22C25;
            padding:14px;
            border-radius:10px;
            font-size:14px;
            line-height:1.5;
            margin:18px 0;
        }
        .give-checkout {
            padding-top:20px;
            border-top:1px solid #E4E8EC;
        }
        .give-total {
            display:flex;
            align-items:center;
            justify-content:space-between;
            gap:12px;
            font-size:14px;
            font-weight:800;
        }
        .give-checkout p {
            color:#5A6870;
            font-size:13px;
            margin:14px 0;
        }
        .give-primary {
            width:100%;
            min-height:52px;
            border:0;
            border-radius:99px;
            padding:13px 18px;
            background:var(--give-accent,var(--dot-action));
            color:var(--give-accent-text,white);
        }
        .give-primary:hover:not(:disabled) {
            background:var(--give-accent,var(--dot-action-hover));
            filter:brightness(.94);
        }
        .give-secondary {
            border:1px solid currentColor;
            border-radius:99px;
            padding:9px 16px;
            background:transparent;
            color:inherit;
            margin-top:12px;
            margin-right:8px;
        }
        .give-form button:disabled {
            cursor:default;
            opacity:.6;
        }
        .give-form fieldset:disabled {
            opacity:.75;
        }
        .give-panel footer {
            text-align:center;
            color:#5A6870;
            font-size:11px;
            margin-top:30px;
        }
        .give-unavailable {
            max-width:620px;
            margin:10vh auto;
            padding:32px;
            font-family:'Nunito Sans',sans-serif;
            line-height:1.7;
        }
        .give-unavailable button {
            padding:12px 24px;
            border:0;
            border-radius:99px;
            background:var(--dot-action);
            color:white;
            font-weight:800;
            cursor:pointer;
        }
        .give-unavailable button:hover:not(:disabled) {
            background:var(--dot-action-hover);
            color:white;
        }
        .give-skeleton {
            height:250px;
            border-radius:16px;
            background:linear-gradient(90deg,#E4E8EC,#EFF1F4,#E4E8EC);
        }
        .give-status {
            padding:60px 0;
            line-height:1.7;
        }
        @media(max-width:1000px) {
            .give-story {
                padding:40px 32px;
            }
            .give-panel {
                padding:42px 28px;
            }
            .give-story h1 {
                font-size:35px;
            }
        }
        @media(max-width:700px) {
            .give-story-text.collapsible:not(.expanded) { display:-webkit-box; -webkit-line-clamp:5; -webkit-box-orient:vertical; overflow:hidden; }
            .give-story-expand { display:inline-block; }
            .give-layout {
                display:block;
            }
            .give-story {
                padding:25px 24px 23px;
            }
            .give-brand {
                font-size:19px;
                margin-bottom:28px;
            }
            .give-eyebrow {
                font-size:10px;
                margin-bottom:12px;
            }
            .give-story h1 {
                font-size:30px;
                line-height:1.22;
                margin-bottom:12px;
            }
            .give-story-copy {
                font-size:14px;
                line-height:1.65;
                margin:0;
            }
            .give-progress {
                margin:22px 0 0;
                padding:16px;
            }
            .give-progress strong {
                font-size:20px;
            }
            .give-progress p {
                margin-bottom:0;
            }
            .give-story-foot {
                display:none;
            }
            .give-panel {
                padding:30px 22px 24px;
            }
            .give-form h2 {
                font-size:25px;
            }
            .give-amount {
                min-height:78px;
            }
            .give-form fieldset {
                margin:24px 0;
            }
            .give-notice {
                padding:14px;
            }
            .give-status {
                padding:20px 0;
            }
        }
        """
        }
    }
